import _ from 'lodash';

import {MessageTypesEnum} from '../../../../libs/shared/core/src/models/api/commonMessageModel';
import {MessageModel} from '../../../../libs/shared/core/src/models/api/messageModel';
import {emlFileName} from '../../../helpers/models/messageHelpers';
import {DraggedMessageItemModel} from '../../common/attachments/attachmentsDragAndDrop';

export function computeCellDragSourceMessageAttachments(
  messages: ReadonlyArray<MessageModel>,
): ReadonlyArray<DraggedMessageItemModel> {
  return _(messages)
    .map(
      (message) =>
        message.type === MessageTypesEnum.EMAIL && {
          messageUid: message.uid,
          emlFileName: emlFileName(message),
        },
    )
    .compact()
    .value();
}
